
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

    class Coordinates {
        x: number;
        y: number;
        constructor(x: number, y: number) {
            this.x = x;
            this.y = y;
        }
    }

    @Component
    export default class Connector extends Vue {
        @Prop() private from?: Vue;
        @Prop() private to?: Vue;

        private fromCoordinates = new Coordinates(0, 0);
        private toCoordinates = new Coordinates(0, 0);
        private lineCenter = new Coordinates(0, 0);
        private smallPolygonPoints = '';
        private largePolygonPoints = '';
        private polygonRotation = 0.;

        mounted() {
            // Update the lines on resize
            window.addEventListener('resize', this.update.bind(this));

            this.$nextTick(() => {
                this.update();
            });
        }

        beforeDestroy() {
            window.removeEventListener('resize', this.update.bind(this));
        }

        @Watch('from')
        @Watch('to')
        update() {
            if (!this.from || !this.from.$el) {
                return;
            }
            if (!this.to || !this.to.$el) {
                return;
            }
            this.fromCoordinates = this.offsetBySelfPosition(
                Connector.center(this.from.$el.getBoundingClientRect())
            );
            this.toCoordinates = this.offsetBySelfPosition(
                Connector.center(this.to.$el.getBoundingClientRect())
            );
            // Arrow
            this.lineCenter = new Coordinates(
                this.fromCoordinates.x + (this.toCoordinates.x - this.fromCoordinates.x) / 2 + 2,
                this.fromCoordinates.y + (this.toCoordinates.y - this.fromCoordinates.y) / 2,
            );
            this.smallPolygonPoints = (this.lineCenter.x - 8) + ',' + (this.lineCenter.y - 8) + ' '
                + (this.lineCenter.x - 8) + ',' + (this.lineCenter.y + 8) + ' '
                + (this.lineCenter.x + 8) + ',' + this.lineCenter.y;
            this.largePolygonPoints = (this.lineCenter.x - 12) + ',' + (this.lineCenter.y - 12) + ' '
                + (this.lineCenter.x - 12) + ',' + (this.lineCenter.y + 12) + ' '
                + (this.lineCenter.x + 12) + ',' + this.lineCenter.y;

            const horizontalTargetCoordinates = new Coordinates(
                this.toCoordinates.x,
                this.fromCoordinates.y,
            );
            this.polygonRotation = 90 - Connector.angle(this.fromCoordinates, this.toCoordinates, horizontalTargetCoordinates);
            if (this.toCoordinates.y < this.fromCoordinates.y) {
                this.polygonRotation = -this.polygonRotation;
            }
        }

        private static center(rect: DOMRect) {
            const x = rect.left + (rect.right - rect.left) / 2;
            const y = rect.top + (rect.bottom - rect.top) / 2;
            return new Coordinates(x, y);
        }
        private offsetBySelfPosition(coordinates: Coordinates) {
            const self = this.$el.getBoundingClientRect();
            return new Coordinates(
                coordinates.x - self.left,
                coordinates.y - self.top,
            );
        }

        private static angle(A: Coordinates, B: Coordinates, C: Coordinates) {
            const AB = Math.sqrt(Math.pow(B.x-A.x,2)+ Math.pow(B.y-A.y,2));
            const BC = Math.sqrt(Math.pow(B.x-C.x,2)+ Math.pow(B.y-C.y,2));
            const AC = Math.sqrt(Math.pow(C.x-A.x,2)+ Math.pow(C.y-A.y,2));
            const radianAngle = Math.acos((BC*BC+AB*AB-AC*AC)/(2*BC*AB));
            return (radianAngle * 180) / Math.PI;
        }
    }
